import { api } from './api';

// Payments API
export const paymentsApi = {
  createCheckout: (bookingId, token) => api.post('/api/payments/create-checkout', { 
    booking_id: bookingId,
    frontend_url: window.location.origin  // Pass current domain for correct redirect
  }, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  getPaymentStatus: (sessionId, token) => api.get(`/api/payments/status/${sessionId}`, {
    headers: { Authorization: `Bearer ${token}` }
  }),
};

// Availability API
export const availabilityApi = {
  create: (data, token) => api.post('/api/availability', data, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  getByListing: (listingId, startDate, endDate) => {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    return api.get(`/api/availability/${listingId}`, { params });
  },
};